import React, { useState, useMemo } from 'react'
import MirsTable from 'components/general/table/Table'
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { useNavigateTo, useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC, getRscObject } from "helpers/rsc"
import {
  ColumnDateTime,
  ColumnStartTime,
  ColumnStatus,
  ColumnEvent,
  ColumnEventWithCompetitor,
  ColumnCompetitor,
  ColumnResult,
  ColumnDiscipline,
  ColumnLocation
} from "components/common/schedule/TableColumns";
import { getEventRSC } from 'AppRouter';
import SelectorTimeZone from '../selectors/selector-timezone';

const getConfiguration = (breakPoint, paramsURL, getURL) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: 'Time', desc: false }];
  configuration.columns = isMobile ? TableColumnsSM(paramsURL, getURL) : TableColumns(paramsURL, getURL)
  return configuration;
};

export default function BioSchedule({ data }) {
  const { breakPoint } = useViewport();
  const isTeam = (data?.team)
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }
  const getURL = useGetURL()
  const bioData = (isTeam) ? { ...data?.team } : { ...data?.person }
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')

  bioData.schedules = bioData?.schedules?.reduce((reducedArray, currentItem) => {
    // Check if the code is already present in the new array
    let isCodePresent = reducedArray?.some(item => item.code === currentItem.code);

    // If the code is not present, add the current item to the new array
    if (!isCodePresent) {
      reducedArray.push(currentItem);
    }

    return reducedArray;
  }, []);

  const handleClick = (props) => {
    const resultRSC = (props?.eventUnit?.resultRSC)
    const rsc = resultRSC || props?.eventUnit?.code;
    const objRsc = getRscObject(rsc)

    /*if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT" || !resultRSC) {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
      paramsURL["mirs_discipline"] = objRsc.discipline

    } else {
      //Phase or unit
      // paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_event"] = getEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
      paramsURL["mirs_discipline"] = objRsc.discipline
    }*/
    paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc);
    paramsURL["mirs_event"] = getEventRSC(rsc)
    paramsURL["mirs_rsc"] = rsc
    paramsURL["mirs_discipline"] = objRsc.discipline
    setParamsUrl(paramsURL);
    if (rsc?.indexOf('TRNO') === -1 && rsc?.indexOf('TMRY') === -1 && (props?.status?.code !== "CANCELLED") && (props?.eventUnit?.type !== "NONE")) {
      setShouldNavigate(true);
    }
  };

  const config = useMemo(() => getConfiguration(breakPoint, paramsURL, getURL), [breakPoint]);
  let hiddenColumns = [] //hasMoreThanOneDisc ? [] : ['Discipline']

  return (
    <>

      <div className="d-flex flex-row align-items-baseline">
        <div id="schedule"><h2 className="wrsBiosDetail__h2 me-3" id="table-bioschedule"><Label data="LabelSchedule" /></h2></div>
        <SelectorTimeZone />
      </div>
      {data && bioData?.schedules ?
        < MirsTable initialSortBy={config.sortBy}
          data={bioData?.schedules}
          hiddenColumns={hiddenColumns}
          columns={config.columns}
          rowOnClick={true}
          ariaLabelledby={"table-bioschedule"}
          rowClickHandler={handleClick}
          keyRow='code'
          getRowProps={row => (
            {
              className: (row.original?.code?.indexOf('TRNO') === -1 && row.original?.code?.indexOf("TMRY") === -1 && (row.original?.status?.code !== "CANCELLED") && (row.original?.eventUnit?.type !== "NONE")) ? 'clickable-row' : ''
            }
          )}
        />
        : <b><Label data="HeaderScheduleNotAvailable" /> </b>
      }
    </>
  )
}


function TableColumns(paramsURL, getURL) {
  return (
    [
      ColumnDateTime({ disableSort: true, label: 'HeaderStartTime' }),
      ColumnStartTime({ disableSort: true, label: '', id: "StartTime" }),
      ColumnLocation({ disableSort: true }),
      ColumnDiscipline({ disableSort: true, showDesc: true }),
      ColumnEvent({ disableSort: true, paramsURL, getURL }),
      ColumnCompetitor({ paramsURL }),
      ColumnResult({}),
      ColumnStatus({})
    ]
  )
}

function TableColumnsSM(paramsURL, getURL) {
  return (
    [
      ColumnDateTime({ disableSort: true, label: 'HeaderStartTime' }),
      ColumnDiscipline({ disableSort: true, showDesc: true }),
      ColumnEventWithCompetitor({ disableSort: true, paramsURL, getURL }),
      ColumnResult({}),
      ColumnStatus({}),
    ]
  )
}
